import React from 'react';
import styled from 'styled-components';
import './RecentWork.scss';
import { RecentWorkCard } from 'components';
import Section from '../components/Section';
import Button from '../components/Button';

const CardsContainer = styled.div`
  display: grid;
  justify-content: center;
  grid-column-gap: 4.8rem;
  grid-row-gap: 4.8rem;
  grid-template-columns: repeat(2, minmax(330px, 1fr));
  /* @TODO change when specific design available */
  ${({ theme }) => theme.breakpoints.maxMobile} {
    grid-template-columns: minmax(min-content, 1fr);
    grid-template-rows: auto auto;
  }
`;

const RecentWork = ({
  data: {
    sectionTitle: { subTitle, title, button },
    cards,
  },
}) => (
  <Section className="recent-work" subTitle={subTitle} title={title} button={button}>
    <CardsContainer>
      {cards.map((card, index) => (
        <RecentWorkCard
          image={card.imageContainer.image.childImageSharp.fluid}
          altText={card.imageContainer.altText}
          title={card.title}
          description={card.description}
          url={card.projectUrl}
          key={card.title}
          index={index}
        />
      ))}
    </CardsContainer>
    <Button className="recent-work__button-mobile" to={button.url} variant="secondary">
      {button.text}
    </Button>
  </Section>
);

export default RecentWork;
